export default {"src":"/_next/static/media/arrow-right-gray.84b73e51.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};